import React, { useState, useEffect } from 'react';
import './index.css';
import Persons from './components/Persons';
import Cards from './components/Cards';
import Transactions from './components/Transactions';
import Withdrawals from './components/Withdrawals';
import Salaries from './components/Salaries';
import SBO from './components/SBO';
import Reports from './components/Reports';
import Notes from './components/Notes';
import Login from './components/Login';
import { checkAuth, logout } from './api';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('reports');
  const [dateLocale, setDateLocale] = useState('fa');

  useEffect(() => {
    verifyAuth();
  }, []);

  const verifyAuth = async () => {
    try {
      const response = await checkAuth();
      if (response.data.authenticated) {
        setIsAuthenticated(true);
      }
    } catch (err) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    try {
      await logout();
      setIsAuthenticated(false);
    } catch (err) {
      console.error('Logout error:', err);
      setIsAuthenticated(false);
    }
  };

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  const tabs = [
    { id: 'reports', label: 'گزارش' },
    { id: 'cards', label: 'کارت‌ها' },
    { id: 'transactions', label: 'ورودی ریالی' },
    { id: 'sbo', label: 'ورودی دلاری' },
    { id: 'withdrawals', label: 'برداشت‌ها' },
    { id: 'salaries', label: 'حقوق' }, 
    { id: 'notes', label: 'نت' },
    { id: 'persons', label: 'اشخاص' },
  ];

  return (
    <div className="bg-body-tertiary min-vh-100 py-4">
      <div className="container-fluid">
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-body d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
            <div>
              <h1 className="h3 mb-1 fw-bold">سیستم حسابداری شخصی</h1>
              <p className="text-muted mb-0">مدیریت متمرکز تراکنش‌ها، برداشت‌ها و پرداخت‌ها</p>
            </div>
            <div className="d-flex flex-wrap align-items-center gap-2">
              <label className="fw-semibold text-muted" htmlFor="date-locale">نوع تاریخ:</label>
              <select
                id="date-locale"
                className="form-select form-select-sm w-auto"
                value={dateLocale}
                onChange={(e) => setDateLocale(e.target.value)}
              >
                <option value="fa">تاریخ فارسی</option>
                <option value="en">تاریخ انگلیسی</option>
              </select>
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={handleLogout}
              >
                خروج
              </button>
            </div>
          </div>
        </div>

        <div className="card border-0 shadow-sm mb-4">
          <div className="card-body p-3">
            <ul className="nav nav-pills flex-wrap justify-content-start gap-2">
              {tabs.map((tab) => (
                <li className="nav-item" key={tab.id}>
                  <button
                    type="button"
                    className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="d-grid gap-4">
          {activeTab === 'persons' && <Persons />}
          {activeTab === 'cards' && <Cards />}
          {activeTab === 'transactions' && <Transactions dateLocale={dateLocale} />}
          {activeTab === 'withdrawals' && <Withdrawals dateLocale={dateLocale} />}
          {activeTab === 'salaries' && <Salaries dateLocale={dateLocale} />}
          {activeTab === 'sbo' && <SBO dateLocale={dateLocale} />}
          {activeTab === 'notes' && <Notes dateLocale={dateLocale} />}
          {activeTab === 'reports' && <Reports dateLocale={dateLocale} />}
        </div>
      </div>
    </div>
  );
}

export default App;

